import React, { useEffect } from 'react';
import OneVerseLogo from '@/components/OneVerseLogo';
import ReactMarkdown from 'react-markdown';
import { useTermsData } from '@/hooks/useTermsData';

const Terms: React.FC = () => {
  const { termsData, loading, error } = useTermsData();

  useEffect(() => {
    document.body.classList.add('bg-gray-50');
    return () => {
      document.body.classList.remove('bg-gray-50');
    };
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 py-8 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-8">
            <OneVerseLogo className="mb-6 mt-2 mx-auto" />
          </div>
          <div className="bg-white shadow rounded-lg p-8">
            <div className="text-center">Loading terms and conditions...</div>
          </div>
        </div>
      </div>
    );
  }

  if (error || !termsData) {
    return (
      <div className="min-h-screen bg-gray-50 py-8 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-8">
            <OneVerseLogo className="mb-6 mt-2 mx-auto" />
          </div>
          <div className="bg-white shadow rounded-lg p-8">
            <div className="text-center text-red-600">
              {error || 'Failed to load terms and conditions'}
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 py-8 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-8">
          <a href="/" className="inline-block">
            <OneVerseLogo className="mb-6 mt-2 mx-auto" />
          </a>
        </div>

        <div className="bg-white shadow rounded-lg p-8">
          <div className="mb-6 pb-4 border-b border-gray-200">
            <h1 className="text-2xl font-semibold text-gray-900">
              {termsData.title}
            </h1>
            <div className="mt-2 text-sm text-gray-500">
              Version {termsData.version} • Effective{' '}
              {new Date(termsData.effective_date).toLocaleDateString()}
            </div>
          </div>

          <div className="prose prose-gray max-w-none prose-headings:font-semibold prose-h1:text-3xl prose-h2:text-2xl prose-h3:text-xl prose-p:text-gray-600 prose-li:text-gray-600 prose-a:text-blue-600 hover:prose-a:text-blue-800">
            <ReactMarkdown>{termsData.content}</ReactMarkdown>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Terms;
